export default "__VITE_ASSET__DYsgM8TI__"